/*
 * Public API Surface of iris
 */
export * from './lib/avatar/avatar.component';
export * from './lib/avatar/avatar.module';
export * from './lib/dropzone/dropzone.component';
export * from './lib/dropzone/dropzone.module';
export * from './lib/dropzone/dragdrop.directive';
export * from './lib/iris.module';
